module.exports = __webpack_public_path__ + "img/link_cards_2x.fc152f78.png";